'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'badge-check';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f336';
var svgPathData = ['M32 256l.2 5.3c1.8 26.1 17.2 48.5 39.2 60.1l11.7 6.2-3.9 12.7c-7.8 25.4-1.7 54.1 18.4 74.2 20 20 48.7 26.2 74.2 18.3l12.6-3.9 6.2 11.7c12.4 23.5 37.1 39.5 65.4 39.5 28.3 0 53-16 65.4-39.5l6.2-11.7 12.7 3.9c25.4 7.8 54.1 1.7 74.2-18.3s26.2-48.7 18.3-74.2l-3.9-12.7 11.7-6.2c23.5-12.4 39.5-37.1 39.5-65.4 0-28.3-16-53-39.5-65.4l-11.7-6.2 3.9-12.6c7.8-25.4 1.7-54.1-18.3-74.2-20-20-48.7-26.2-74.2-18.4l-12.7 3.9-6.2-11.7C309 47.9 284.3 32 256 32 227.7 32 203 48 190.6 71.4l-6.2 11.7-12.6-3.9c-25.4-7.8-54.1-1.7-74.2 18.4s-26.2 48.7-18.4 74.2l3.9 12.6-11.7 6.2C48 203 32 227.7 32 256zm121.4 12.1l23-22.2c2.4 2.5 19.8 20.5 52.3 54.1l94.4-129.8 9.4-12.9 25.9 18.8-9.4 12.9-105.6 145.2-11.2 15.4-13.2-13.7-54.4-56.3-11.1-11.5z', 'M256 0c36.1 0 68 18.1 87.1 45.7 33-6 68.4 3.7 94 29.3s35.2 60.9 29.2 93.9C493.8 188 512 219.8 512 256s-18.2 68-45.8 87.1c6 33-3.6 68.4-29.2 94s-61 35.2-94 29.2C324 493.8 292.2 512 256 512s-68-18.2-87.1-45.8c-33 6-68.3-3.6-93.9-29.2s-35.3-60.9-29.3-94C20.1 325.3 2.6 296.6 .3 263.6L0 256c0-36.1 18.1-68 45.7-87.1-6-33 3.7-68.3 29.3-93.9s60.9-35.3 93.9-29.3C188 18.1 219.9 0 256 0zm0 32c-28.3 0-53 16-65.4 39.4l-6.2 11.7-12.6-3.9c-25.4-7.8-54.1-1.7-74.2 18.4s-26.2 48.7-18.4 74.2l3.9 12.6-11.7 6.2C48 203 32 227.7 32 256l.2 5.3c1.8 26.1 17.2 48.5 39.2 60.1l11.7 6.2-3.9 12.7c-7.8 25.4-1.7 54.1 18.4 74.2 20 20 48.7 26.2 74.2 18.3l12.6-3.9 6.2 11.7c12.4 23.5 37.1 39.5 65.4 39.5 28.3 0 53-16 65.4-39.5l6.2-11.7 12.7 3.9c25.4 7.8 54.1 1.7 74.2-18.3s26.2-48.7 18.3-74.2l-3.9-12.7 11.7-6.2c23.5-12.4 39.5-37.1 39.5-65.4 0-28.3-16-53-39.5-65.4l-11.7-6.2 3.9-12.6c7.8-25.4 1.7-54.1-18.3-74.2-20-20-48.7-26.2-74.2-18.4l-12.7 3.9-6.2-11.7C309 47.9 284.3 32 256 32zM358.3 176.1l-9.4 12.9-105.6 145.2-11.2 15.4-13.2-13.7-54.4-56.3-11.1-11.5 23-22.2c2.4 2.5 19.8 20.5 52.3 54.1l94.4-129.8 9.4-12.9 25.9 18.8z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBadgeCheck = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;